import { render, staticRenderFns } from "./MoveWrap.vue?vue&type=template&id=20967a63&scoped=true&"
import script from "./MoveWrap.vue?vue&type=script&lang=js&"
export * from "./MoveWrap.vue?vue&type=script&lang=js&"
import style0 from "./MoveWrap.vue?vue&type=style&index=0&id=20967a63&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20967a63",
  null
  
)

export default component.exports